import { CustomIconProps } from './index';

export const ClickIcon = ({ color }: CustomIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            fill="none"
            viewBox="0 0 24 24">
            <circle
                cx={12}
                cy={12}
                r={11}
                fill="#fff"
                stroke={color || 'black'}
                strokeWidth={2}
            />
            <path
                fill={color || 'black'}
                fillRule="evenodd"
                d="M15.986 9.996L7 7l2.996 8.986 1.526-3.052L15.588 17 17 15.588l-4.066-4.066 3.053-1.526z"
                clipRule="evenodd"
            />
        </svg>
    );
};
